<aside class="l-sidebar l-flex l-column scroller mCustomScrollbar _mCS_3">
<img class="off-mobile sidebar-logo" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />

		<!-- user panel (start) -->
		<div class="userPanel">
			
			<i class="userPanel-icon icon-female" *ngIf="pat.ID != 'default'">
				<span class="l-flex t-boxMargin menstural-fields-set">
					
					<button class="btn-user_data" aria-label="user data" (click)="showPatD()" matTooltip="Open Patient Details" [ngClass]="! patservice.getPat().Birth && (es.ExamType == 'NT' || es.ExamType =='1st') ? 'is-invalid':''"></button>
					<div class="t-validation-message">
						<span>Add Birth day by clicking here</span>
					</div>
				</span> 

			</i>

			<div class="userPanel-userName" *ngIf="pat.ID != 'default'">
				{{pat.First}} {{pat.Last}}
			</div>

			<dl class="l-table userPanel-userInfo" *ngIf="pat.ID != 'default'">
				<div class="l-row">
					<dt class="l-td-m">ID Number</dt>
					<dd class="l-td-m">{{pat.ID}}</dd>
				</div>
				<div class="l-row">
					<dt class="l-td-m">Age</dt>
					<dd class="l-td-m">{{patservice.getAgeMo()}}</dd>
				</div>
			</dl>

			<div class="userPanel-controls">
				<a  (click)="bookmark()" class="userPanel-controls-item icon-files" [ngClass]="isBookmark ? 'saved' : ''" aria-label="files" matTooltip="Show Previous Exams in a Window"></a>
			<a (click)="handleClose('/exams')" class="userPanel-controls-item icon-exit" aria-label="exit" matTooltip="Close Exam and Open Patient History"></a>
		</div>
	</div>
		<!-- user panel (end) -->

		<!-- main nav (start) -->
		<nav class="mainNav l-fg1">
			<ul class="mainNav-list">
			<!-- <ng-container *ngIf="es.ExamType !='Consultation Letter' && es.ExamType !== 'consultation and follow up with media' && es.ExamType !== 'Abdomen US' && es.ExamType !== 'MSK Musculoskeletal' && es.ExamType !== 'Ultrasound Scan Summary' && es.ExamType !== 'Hemorrhoids Treatment'">
				<li class="mainNav-item" (click)="setPage('Preparation')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Preparation' ? 'is-active':''">
						Preparation
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('Findings')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Findings' ? 'is-active':''">
						Findings
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('Pathologies')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Pathologies' ? 'is-active':''">
						Pathologies
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('SummaryGastro')">
					<span class="mainNav-link" [ngClass]="currentPage == 'SummaryGastro' ? 'is-active':''">
						Summary
					</span>
				</li>
			</ng-container> -->
			<ng-container *ngIf="es.ExamType === 'Endoscopy'">
				<li class="mainNav-item" (click)="setPage('Preparation')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Preparation' ? 'is-active':''">
						Preparation
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('Findings')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Findings' ? 'is-active':''">
						Findings
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('Pathologies')">
					<span class="mainNav-link" [ngClass]="currentPage == 'Pathologies' ? 'is-active':''">
						Pathologies
					</span>
				</li>
				<li class="mainNav-item" (click)="setPage('EndoscopySummary')">
					<span class="mainNav-link" [ngClass]="currentPage == 'EndoscopySummary' ? 'is-active':''">
						Summary
					</span>
				</li>
			</ng-container>
			<ng-container *ngIf="es.ExamType === 'Abdomen US'">
				<li class="mainNav-item" (click)="setPage('Abdomen US')">
					<span class="mainNav-link" [ngClass]="currentPage === 'Abdomen US' ? 'is-active':''">
						Abdomen US
					</span>
				</li>
			</ng-container>
		<ng-container *ngIf="es.ExamType === 'Hemorrhoids Treatment'">
				<li class="mainNav-item" (click)="setPage('Procedure Summary')">
					<span class="mainNav-link" [ngClass]="currentPage === 'Procedure Summary' ? 'is-active':''">
						Procedure Summary
					</span>
				</li>
			</ng-container>
			<ng-container *ngIf="es.ExamType === 'MSK Musculoskeletal'">
				<li class="mainNav-item" (click)="setPage('MSK Musculoskeletal')">
					<span class="mainNav-link" [ngClass]="currentPage === 'MSK Musculoskeletal' ? 'is-active':''">
						MSK Musculoskeletal
					</span>
				</li>
			</ng-container>
			<ng-container *ngIf="es.ExamType === 'MSK & Soft Tissues'">
				<li class="mainNav-item" (click)="setPage('MSK & Soft Tissues')">
					<span class="mainNav-link" [ngClass]="currentPage === 'MSK & Soft Tissues' ? 'is-active':''">
						MSK &amp; Soft Tissues
					</span>
				</li>
			</ng-container>
			<ng-container *ngIf="es.ExamType === 'Neck scan'">
				<li class="mainNav-item" (click)="setPage('Neck scan')">
					<span class="mainNav-link" [ngClass]="currentPage === 'Neck scan' ? 'is-active':''">
						Neck scan
					</span>
				</li>
			</ng-container>
			<ng-container *ngIf="es.ExamType === 'Ultrasound Scan Summary'">
				<li class="mainNav-item" (click)="setPage('Ultrasound Scan Summary')">
					<span class="mainNav-link" [ngClass]="currentPage === 'Ultrasound Scan Summary' ? 'is-active':''">
						Ultrasound Scan Summary
					</span>
				</li>
			</ng-container>

			</ul>
		</nav>
		<!-- main nav (end) -->

		<app-docpanel></app-docpanel>
		

